import styled from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div`
  .cert-img {
    margin-bottom: 16px;
  }

  .download-btn {
    background: #e8b12c;
    border-radius: 10px;
    padding: 16px 78px;
    font-size: 18px;
    line-height: 23px;
    font-weight: 500;
    color: white;
  }

  .download-sm-btn {
    color: #e8b12c;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    height: 15px;
    margin-top: 7px;
  }

  .right-panel {
    ${tw`flex flex-col items-center justify-center`}
    width: 317px;
    min-width: 317px;
    padding: 25px 0px;
    border: 0.5px solid rgba(98, 120, 140, 0.6);
    border-radius: 20px;
    overflow: auto;
    margin-left: 33px;

    &__title {
      ${tw`text-primary`}
      font-weight: 500;
      font-size: 18px;
      line-height: 23px;
      margin-bottom: 8px;
    }

    .endorsements-certs {
      padding: 0px 35px;
    }

    .cert-sm-title {
      ${tw`text-primary`}
      font-weight: 600;
      margin-top: 15px;
      font-size: 14px;
      line-height: 18px;
    }

    .divider {
      height: 1px;
      background: rgba(98, 120, 140, 0.4);
      margin: 10px 0;
    }
  }

  .no-cert {
    margin-top: 40px;
    .no-cert-text {
      font-size: 40px;
      line-height: 51.28px;
      font-weight: 500;
      color: rgba(24, 28, 52, 0.5);
    }
    .keep-text {
      font-size: 40px;
      line-height: 51.28px;
      font-weight: 500;
    }
  }

  @media only screen and (max-width: 639px) {
    .cert-img {
      margin-bottom: 30px;
    }

    .right-panel {
      margin: 0;
      width: 100%;
    }

    .no-cert {
      margin-top: 24px;

      .no-cert-text {
        font-size: 16px;
      }

      .keep-text {
        font-size: 16px;
      }
    }
  }
`;
